import { Div, DivProps, P } from '@kizi/core-components';
import {
  Accordion,
  AccordionItem,
  IconV2 as Icon,
} from '@kizi/shared-components';
import React from 'react';
import { ProsAndConsItem } from '../utils/product';

export interface ProductProsConsProps extends DivProps {
  cons?: ProsAndConsItem | string[];
  pros?: ProsAndConsItem | string[];
  type?: string;
}

function getItem(title, text, icon): AccordionItem {
  return {
    content: text ? (
      <div>
        <p>{text}</p>
      </div>
    ) : (
      ''
    ),
    icon,
    label: title || '',
  };
}

function prepareData(
  { text1, text2, title1, title2 }: ProsAndConsItem,
  icon?: string,
) {
  let data: AccordionItem[] = [];

  if (title1 && title1 !== ' ') {
    data.push(getItem(title1, text1, icon));
  }
  if (title2 && title2 !== ' ') {
    data.push(getItem(title2, text2, icon));
  }

  return data;
}

function validateObject(obj) {
  return obj && obj['title1'] !== '' && obj['title1'] !== ' ' ? obj : undefined;
}

export const ProductProsCons: React.FC<ProductProsConsProps> = ({
  cons,
  pros,
  type,
  ...restProps
}) => {
  if (type && type === 'solarPanels') {
    return (
      <Div>
        {'Plus- en minpunten'}
        <Div
          display="flex"
          flexDirection="column"
          gridGap="16px"
          mt="16px"
          {...restProps}
        >
          {((pros as string[]) || []).map((el) => (
            <Div display="flex" key={el}>
              <Icon name="green-plus-circle" width={20} height={20} mr={1} />
              <P variant="footnoteRegular">{el}</P>
            </Div>
          ))}
          {((cons as string[]) || []).map((el) => (
            <Div display="flex" key={el}>
              <Icon name="red-cancel-circle" width={20} height={20} mr={1} />
              <P variant="footnoteRegular">{el}</P>
            </Div>
          ))}
        </Div>
      </Div>
    );
  }

  const _cons = validateObject(cons);
  const _pros = validateObject(pros);

  if (!_cons && !_pros) return null;

  return (
    <>
      <Div>{'Plus- en minpunten'}</Div>
      <Div {...restProps}>
        {_pros && (
          <Accordion
            items={prepareData(_pros, 'green-check')}
            variant="prosConsAccordion"
            type="pro-con"
          />
        )}
        {_cons && (
          <Accordion
            items={prepareData(_cons, 'small-cancel')}
            variant="prosConsAccordion"
            type="pro-con"
          />
        )}
      </Div>
    </>
  );
};
